<template>
  <modal id="createShift" v-cloak>
    <div slot="title">
      <h2>Kies je shift</h2>
    </div>
    <div slot="body" class="card">
      <div class="card-body">
        <div class="row justify-content-center">
          <button
              v-for="shiftType in contract.shiftTypes" :key="shiftType.id"
              :value="shiftType.id" @click="handleSelection(shiftType.id)"
              :style="{
                         'color' : giveTextColorForBackGroundColor(shiftType.color),
                         'background-color': shiftType.color,
                         'border-color': shiftType.color }"
              class="btn m-md-2">
            {{ shiftType.name }}
          </button>
        </div>
        <hr>
        <div id="tooltip-vacation">
          <b-dropdown
              v-if="calculateDifferenceInDays() <= remainingVacationDays && (canAdd.VACATION_FULL_DAY || canAdd.VACATION_HALF_DAY)"
              id="dropdown-vacation" text="Voeg vakantie toe"
              class="m-md-2" variant="primary"
              :disabled="!vacationIsApprovedByAdmin">
            <b-dropdown-item
                v-if="canAdd.VACATION_FULL_DAY && fullDayAvailable"
                :value="0" data-type="vacation"
                @click="handleSelectionForVacationOrSickness">Volledige dag</b-dropdown-item>
            <b-dropdown-item
                v-if="canAdd.VACATION_HALF_DAY"
                :value="1" data-type="vacation"
                @click="handleSelectionForVacationOrSickness">Halve dag</b-dropdown-item>
          </b-dropdown>
          <b-dropdown
              id="dropdown-educationalLeave" text="Voeg Vlaams opleidingsverlof toe"
              class="m-md-2" variant="info"
              v-if="calculateDifferenceInDays() <= remainingEducationalLeaveInDays && (canAdd.EDUCATIONAL_LEAVE_FULL_DAY || canAdd.EDUCATIONAL_LEAVE_HALF_DAY)"
              :disabled="!vacationIsApprovedByAdmin">
            <b-dropdown-item
                v-if="canAdd.EDUCATIONAL_LEAVE_FULL_DAY && fullDayAvailable"
                :value="5" data-type="vacation"
                @click="handleSelectionForVacationOrSickness">Volledige dag</b-dropdown-item>
            <b-dropdown-item
                v-if="canAdd.EDUCATIONAL_LEAVE_HALF_DAY"
                :value="6" data-type="vacation"
                @click="handleSelectionForVacationOrSickness">Halve dag</b-dropdown-item>
          </b-dropdown>
          <b-tooltip v-if="!vacationIsApprovedByAdmin" target="tooltip-vacation">Verlof nog te controleren door HR</b-tooltip>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>

import {VoerroModal} from "@voerro/vue-modal";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";
import {toYearAndMonth} from "@/util/DateUtil";
import {vacationList} from "@/constants/Absences";

export default {
  name: "createShiftModal",
  props: ['currentCalendarEntry', 'contract'],
  data() {
    return {
      vacationList,
      test: "test"
    };
  },
  computed: {
    ...mapGetters({
      canAdd: 'timesheet/canAdd',
      remainingVacationDays: 'timesheet/remainingVacationDays',
      remainingRecupInDays: 'timesheet/remainingRecupInDays',
      remainingEducationalLeaveInDays: 'timesheet/remainingEducationalLeaveInDays',
      absenceDays: 'timesheet/absenceDays',
      vacationIsApprovedByAdmin: 'timesheet/vacationApprovedByAdmin'
    }),
    fullDayAvailable: function() {
      let date = moment(this.currentCalendarEntry.start).date();
      let absence = this.absenceDays.filter(absenceDay => moment(absenceDay.start).date() == date);
      return absence.length != 0 ? absence.hours > 3.8 : true;
    }
  },
  methods: {
    ...mapActions("timesheet", ['postPlannedShifts', 'postPlannedShift', 'addAbsence', 'addAbsences', 'fetchAbsenceData']),
    handleSelection(id) {
      const sendPlannedShift = {
        start: this.currentCalendarEntry.start,
        end: this.currentCalendarEntry.end,
        shiftId: id
      };
      this.breakAndSendEvent(sendPlannedShift);
      VoerroModal.hide("createShift");
    },
    calculateDifferenceInDays() {
      const sendPlannedVacation = {
        start: this.currentCalendarEntry.start,
        end: this.currentCalendarEntry.end,
      };
      const numberOfSelectedDays = moment(sendPlannedVacation.end).diff(moment(sendPlannedVacation.start), 'days');
      if (numberOfSelectedDays > 1) {
        return numberOfSelectedDays;
      } else {
        return 0.5;
      }
    },
    handleSelectionForVacationOrSickness(arg) {
      const dayOfMonth = moment(this.currentCalendarEntry.start).date();
      let absence;
      if (arg.target.getAttribute('data-type') === 'vacation') {
        absence = this.vacationList[arg.target.getAttribute('value')];
      }
      const absenceCategory = absence.absenceCategory;
      const fullDay = absence.fullDay;
      const yearMonth = toYearAndMonth(this.currentCalendarEntry.start);

      const createAbsenceDto = {
        dayOfMonth,
        absenceCategory,
        fullDay
      };

      const createAbsencesDto = {
        startDateOfFirstAbsence: moment(this.currentCalendarEntry.start).format('YYYY-MM-DD'),
        startDateOfLastAbsence: moment(this.currentCalendarEntry.end).subtract(1, 'day').format('YYYY-MM-DD'),
        absenceCategory,
        fullDay
      };

      const differenceInDays = this.calculateDifferenceInDays();
      if (differenceInDays > 1) {
        this.addAbsences({yearMonth, createAbsencesDto});
      } else {
        this.addAbsence({yearMonth, createAbsenceDto});
      }
      this.fetchAbsenceData();
      VoerroModal.hide("createShift");
    },
    breakAndSendEvent(plannedShift) {
      const startingDate = moment(plannedShift.start);
      const endingDate = moment(plannedShift.end);

      const differenceInDays = endingDate.diff(startingDate, 'days');
      if (differenceInDays > 1) {
        this.postEvents(startingDate, endingDate, plannedShift.shiftId);
      } else {
        const dateToMoment = moment(plannedShift.start).locale('nl');
        this.postEvent(plannedShift, dateToMoment);
      }
    },
    postEvent(newEvent, dateToMoment) {
      const plannedShiftDto = {
        startDate: dateToMoment.format("YYYY-MM-DD"),
        shiftId: newEvent.shiftId
      };
      const yearMonth = toYearAndMonth(dateToMoment);
      this.postPlannedShift({
        yearMonth,
        plannedShift: plannedShiftDto,
        contractId: this.contract.id
      });
    },
    postEvents(startingDate, endingDate, shiftId) {
      const createPlannedShiftsDto = {
        startDateOfFirstShift: startingDate.format('YYYY-MM-DD'),
        startDateOfLastShift: endingDate.subtract(1, 'day').format('YYYY-MM-DD'),
        shiftId
      };
      const yearMonth = toYearAndMonth(startingDate);
      this.postPlannedShifts({
        yearMonth,
        createPlannedShiftsDto
      });
    },
    giveTextColorForBackGroundColor(color) {
      return giveTextColorForBackGroundColor(color);
    }
  }
};
</script>

<style scoped>
.btn {
  color: white;
  background-color: #9D2236 ;
}
</style>